"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.RED_COLOR = exports.ACTION_TXT = exports.ACTION_BTN = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    ACTION_BTN = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center",
  border: "none",
  height: "50px",
  width: "200px",
  fontSize: _vars.FONT_SIZES.small,
  fontWeight: _vars.FONT_WEIGHTS.regular,
  ":hover": {
    backgroundColor: _vars.COLOURS.grey.athens.bigFat
  }
});

exports.ACTION_BTN = ACTION_BTN;
var ACTION_TXT = (0, _cxs["default"])({
  padding: "0 20px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "uppercase",
  textAlign: "center"
});
exports.ACTION_TXT = ACTION_TXT;
var RED_COLOR = (0, _cxs["default"])({
  color: _vars.COLOURS.red.redApple
});
exports.RED_COLOR = RED_COLOR;